import { createAnalyticsColumnHeader } from './createAnalyticsColumnHeader';
import { SHIPMENT_COLUMN_NAME_MAP } from './constants/shipmentColumnConfig';

/**
 * Shipment column header component
 * Generated using shared factory to eliminate code duplication
 */
export const ShipmentColumnHeader = createAnalyticsColumnHeader({
  tableType: 'SHIPMENTS',
  columnNameMap: SHIPMENT_COLUMN_NAME_MAP,
});
